"use strict";

exports.__esModule = true;
exports.MetricFilters = MetricFilters;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _fetchSection = require("../../../VIMANAMetrics/Sections/fetchSection");
var _Core = require("../../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var clone = require("ramda").clone;
function itemPredicate(query, item) {
  try {
    return item.label.toLowerCase().includes(query.toLowerCase());
  } catch (error) {
    console.warn("Error in item predicate", JSON.stringify(error));
    return true;
  }
}
function MetricFilters(props) {
  var filters = (0, _fetchSection.fetchSection)("filters").filter(function (filter) {
    return filter.props.presentation.showInEditor;
  });
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path;

  // $FlowFixMe
  return filters.map(function (filter) {
    var elementFilters = clone(element.props.filters);
    var indexOfTheFilter = elementFilters.findIndex(function (f) {
      return f.name === filter.name;
    });
    if (filter.props.presentation.component === "ButtonGroup" && filter.props.values.source === "input") {
      var filterValues = indexOfTheFilter >= 0 ? elementFilters[indexOfTheFilter].values : [];
      return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        style: {
          marginTop: "10px"
        },
        key: "MetricFilters." + filter.label,
        label: filter.label
      }, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, null, filter.props.values.data.map(function (button) {
        return /*#__PURE__*/_react["default"].createElement(_core.Button, {
          "data-testid": button.id,
          key: button.id,
          style: filterValues.includes(button.id) ? {
            textDecoration: "line-through"
          } : {},
          text: button.label,
          onClick: function onClick() {
            if (indexOfTheFilter < 0) {
              elementFilters[elementFilters.length] = {
                filterGroup: filter.props.setType ? filter.props.setType(button) : "must",
                name: filter.name,
                values: [button.id]
              };
            } else {
              if (filterValues.includes(button.id)) {
                filterValues = filterValues.filter(function (val) {
                  return val !== button.id;
                });
              } else {
                filterValues = filterValues.concat(button.id);
              }
              elementFilters[indexOfTheFilter] = {
                filterGroup: filter.props.setType ? filter.props.setType(button) : "must",
                name: filter.name,
                values: filterValues
              };
            }
            elementEditor.setProp(path, "filters", elementFilters);
          }
        });
      })));
    }
    if (filter.props.presentation.component === "Selector") {
      var items = filter.props.values.data;
      var selectedItems = [];
      if (indexOfTheFilter >= 0) {
        var _filterValues = elementFilters[indexOfTheFilter].values;
        selectedItems = _filterValues.map(function (filterValue) {
          return items.find(function (item) {
            return item.id === filterValue;
          });
        }).filter(function (filterValue) {
          return filterValue !== undefined;
        });
      } else {
        selectedItems = filter.props.values.defaultSelected || [];
      }
      return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        style: {
          marginBottom: "10px"
        },
        key: "MetricFilters." + filter.label,
        label: filter.label
      }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
        dataTestId: "MetricFilters." + filter.label,
        multiple: filter.props.presentation.multiSelect,
        items: items,
        selected: selectedItems,
        getKey: function getKey(item) {
          return item.id;
        },
        renderItemText: function renderItemText(item) {
          return item.label;
        },
        itemPredicate: itemPredicate,
        onSelect: function onSelect(selected) {
          var elementFilter = {
            filterGroup: filter.props.setType ? filter.props.setType(selected[0]) : "must",
            name: filter.name,
            values: selected.map(function (item) {
              return item.id;
            })
          };
          if (indexOfTheFilter < 0) {
            elementFilters[elementFilters.length] = elementFilter;
          } else {
            elementFilters[indexOfTheFilter] = elementFilter;
          }
          elementEditor.setProp(path, "filters", elementFilters);
        }
      }));
    }
    return null;
  });
}